import axios from 'axios';
import { getAuthHeaders } from './config';

const BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetch mystery client data versions
 */
export const fetchVersions = async () => {
  const response = await axios.get(`${BASE_URL}/api/data/mistery`, {
    headers: getAuthHeaders(),
  });

  if (response.status !== 200) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

/**
 * Generate JSON from shapefile and sqlite
 */
export const generateJSON = async (shapefileZip, sqliteFile, renameScenarios, vehicleLengths) => {
  const formData = new FormData();
  formData.append('shapefile_zip', shapefileZip);
  formData.append('sqlite_file', sqliteFile);
  formData.append('rename_scenari', JSON.stringify(renameScenarios));
  formData.append('vehicle_lengths', JSON.stringify(vehicleLengths));

  const response = await axios.post(`${BASE_URL}/api/json-generator/generate`, formData, {
    headers: {
      ...getAuthHeaders('multipart/form-data'),
    },
  });

  if (response.status !== 200) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

/**
 * Upload mystery client data
 */
export const uploadMysteryData = async (formData) => {
  const response = await axios.post(`${BASE_URL}/api/data/mistery`, formData, {
    headers: {
      ...getAuthHeaders('multipart/form-data'),
    },
  });

  return response;
};
